import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { updateUserApi } from "../../../store/UpdateUserDataSlicer";
import { getJobsFunc } from "../../../store/Slices/jobs/GetJobsSlicer";
// import UpadteJobForm from "./UpdateJobForm";
import LoadingScreen from "../loading-overlay/LoadingScreen";
import { getFeedbacksFunc } from "../../../store/Slices/feedbacks/GetFeedbacksSlicer";
import { deleteFeedbackFunc } from "../../../store/Slices/feedbacks/DeleteFeedbackSlicer";
import UpdateFeedbackForm from "./UpdateFeedbackForm";
import defaultImg from "../../../images/logos.7417b3f27a859bc676aa.png"

function CustomDropDownBlog(props) {
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as="a"
          className="btn-link i-false btn sharp tp-btn-light btn-dark"
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.0012 9.86C11.6544 9.86 11.3109 9.92832 10.9905 10.061C10.67 10.1938 10.3789 10.3883 10.1336 10.6336C9.88835 10.8788 9.6938 11.17 9.56107 11.4905C9.42834 11.8109 9.36002 12.1544 9.36002 12.5012C9.36002 12.848 9.42834 13.1915 9.56107 13.5119C9.6938 13.8324 9.88835 14.1236 10.1336 14.3688C10.3789 14.6141 10.67 14.8086 10.9905 14.9413C11.3109 15.0741 11.6544 15.1424 12.0012 15.1424C12.7017 15.1422 13.3734 14.8638 13.8687 14.3684C14.3639 13.873 14.642 13.2011 14.6418 12.5006C14.6417 11.8001 14.3632 11.1284 13.8678 10.6332C13.3724 10.138 12.7005 9.85984 12 9.86H12.0012ZM3.60122 9.86C3.25437 9.86 2.91092 9.92832 2.59048 10.061C2.27003 10.1938 1.97887 10.3883 1.73361 10.6336C1.48835 10.8788 1.2938 11.17 1.16107 11.4905C1.02834 11.8109 0.960022 12.1544 0.960022 12.5012C0.960022 12.848 1.02834 13.1915 1.16107 13.5119C1.2938 13.8324 1.48835 14.1236 1.73361 14.3688C1.97887 14.6141 2.27003 14.8086 2.59048 14.9413C2.91092 15.0741 3.25437 15.1424 3.60122 15.1424C4.30171 15.1422 4.97345 14.8638 5.46866 14.3684C5.96387 13.873 6.24198 13.2011 6.24182 12.5006C6.24166 11.8001 5.96324 11.1284 5.46781 10.6332C4.97237 10.138 4.30051 9.85984 3.60002 9.86H3.60122ZM20.4012 9.86C20.0544 9.86 19.7109 9.92832 19.3905 10.061C19.07 10.1938 18.7789 10.3883 18.5336 10.6336C18.2884 10.8788 18.0938 11.17 17.9611 11.4905C17.8283 11.8109 17.76 12.1544 17.76 12.5012C17.76 12.848 17.8283 13.1915 17.9611 13.5119C18.0938 13.8324 18.2884 14.1236 18.5336 14.3688C18.7789 14.6141 19.07 14.8086 19.3905 14.9413C19.7109 15.0741 20.0544 15.1424 20.4012 15.1424C21.1017 15.1422 21.7734 14.8638 22.2687 14.3684C22.7639 13.873 23.042 13.2011 23.0418 12.5006C23.0417 11.8001 22.7632 11.1284 22.2678 10.6332C21.7724 10.138 21.1005 9.85984 20.4 9.86H20.4012Z"
              fill="#A098AE"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-menu dropdown-menu-end"
          align="right"
        >
          <Dropdown.Item
            onClick={() => {
                // props.handleClick("DELETE", props.dataitem)
                props.deleteJob();
            }}
          >
            Delete
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
                props.showupdateform()
                // props.handleClick("EDIT", props.dataitem)
            }}
          >
            Edit
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

const FeedbacksPage = () => {
  const { loading: deleteFeedbackLoading } = useSelector(
    (state) => state.deleteFeedbackSlicer
  );
  const dispatch = useDispatch();
  // form controle
  const [userId, setUserId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [showUpdateFeedback, setShowUpdateFeedback] = useState();
  const [feedbackWhichUpdate, setFeedbackWhichUpdate] = useState();

  //form errors
  const [fullNameErrorMessage, setFullNameErrorMessage] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  // const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setUserId("");
    setFullName("");
    setEmail("");
    // setPassword("");
    setPhone("");
    setShow(false);
  };
  const handleShow = (data) => {
    setUserId(data._id);
    setFullName(data.name);
    setEmail(data.email);
    // setPassword(data.password);
    setPhone(data.mobile);
    setShow(true);
  };

  const checkErrorMessages = () => {
    if (
      fullNameErrorMessage === "" &&
      emailErrorMessage === "" &&
      // passwordErrorMessage === "" &&
      phoneErrorMessage === ""
    ) {
      return true;
    }
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!checkErrorMessages()) {
      swal("Worrning!", "Pleace Enter Right Data", "error");
    } else {
      const formData = {
        id: userId,
        name: fullName,
        mobile: phone,
        email: email,
        role: "student",
      };
      dispatch(updateUserApi(formData)).then((res) => {
        if (res.payload.message === " User updated Successfully") {
          Swal.fire("Update Data!", res.payload.message, "success");
          handleClose();
        } else {
          Swal.fire("Error!", `${res.payload.message}`, "info");
        }
        dispatch(getJobsFunc()).then((resulet) => {
          if (resulet.payload.message === "fetched successfully") {
            setFeedbacksArray(resulet.payload.data);
          }
        });
      });
    }
  };

  const { loading, error } = useSelector((state) => state.getFeedbacksSlicer);

  const [feedbacksArray, setFeedbacksArray] = useState([]);
  const [backupData,setBackupData] = useState([]);
  const [showUpdateForm,setShowUpdateForm] = useState();
  const [jobWillUpdate,setJobWillUpdate] = useState();

  useEffect(() => {
    dispatch(getFeedbacksFunc())
    .then((resulet) => {
        console.log(resulet)
      if (resulet.payload.message === "fetched successfully") {
        setFeedbacksArray(resulet.payload.data.feedbacks);
        setBackupData(resulet.payload.data.feedbacks)
      }
    });
  }, []);

  const [data, setData] = useState(
    document.querySelectorAll("#student_wrapper tbody tr")
  );
  const sort = 3;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#student_wrapper tbody tr"));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };


  const deleteFeedback = async (feedbacId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are going to delete this Feedback",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteFeedbackFunc(feedbacId))
          .then((result) => {
            if (result.payload.message === "deleted successfully") {
              Swal.fire("Deleted!", "Feedback has been deleted", "success");
              dispatch(getFeedbacksFunc())
                .then((result) => {
                  if (result.payload.message === "fetched successfully") {
                    setFeedbacksArray(result.payload.data.feedbacks);
                    setBackupData(result.payload.data.feedbacks)
                  }
                });
            } else {
              Swal.fire(
                "Error!",
                "Something bad happened, try again later!!",
                "info"
              );
            }
          });
      }
    });
  };
  

  const feedbacksFilter = (e) => {

    if(e.target.value === ""){
      setFeedbacksArray(backupData)
      return;
    }

    const filterArray = backupData.filter((item) => {
        
      return (
        item.name && item.name.toLowerCase().includes(e.target.value.toLowerCase()) 
        // ||
        // item.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setFeedbacksArray(filterArray);
    console.log(filterArray);
  };

//   useEffect(() => {
//     dispatch(getAll("student")).then((resulet) => {
//       if (resulet.payload.message === "fetched successfully") {
//         setUsers(resulet.payload.data);
//         setBackupData(resulet.payload.data)
//       }
//     });
//     // dispatch(GetUsersSlicer('teacher')).
//   }, []);

const maxRate = 5
const calcRate = (rateCount) => {
  if(rateCount) {
      for(let i=0 ; i <= parseInt(rateCount); i++) {
          const stars = [];
          for (let i = 0; i < parseInt(rateCount); i++) {
              stars.push(
                <i className="fa-solid fa-star text-warning"></i>
              );
          }
          for (let i = 0; i < parseInt(maxRate - rateCount); i++) {
              stars.push(
                <i className="fa-regular fa-star text-warning"></i>
              );
          }
          return (
            <span className="d-flex align-items-center">
                {stars}
                <p className="text-dark m-0" style={{transform: "translateY(1px)translateX(2px)"}}>0.{rateCount}</p>
            </span>
          );
      }
  }
}
  return (
    <>
      <div className="row">
        {loading ? (
          <>
            <div className="row d-flex justify-content-center gap-2">
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
            </div>
          </>
        ) : (
          <>
            <div className="col-xl-12">
              <div className="card students-list">
                <div className="card-header border-0 flex-wrap ">
                  <h4>Reviews List ({feedbacksArray.length})</h4>
                  <div className="d-flex">
                    <div className="input-group search-area w-auto" style={{marginRight : "5px"}}>
                        <span className="input-group-text">
                        <Link to={"#"}>
                            <svg
                            width="24"
                            height="24"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                d="M27.414 24.586L22.337 19.509C23.386 17.928 24 16.035 24 14C24 8.486 19.514 4 14 4C8.486 4 4 8.486 4 14C4 19.514 8.486 24 14 24C16.035 24 17.928 23.386 19.509 22.337L24.586 27.414C25.366 28.195 26.634 28.195 27.414 27.414C28.195 26.633 28.195 25.367 27.414 24.586ZM7 14C7 10.14 10.14 7 14 7C17.86 7 21 10.14 21 14C21 17.86 17.86 21 14 21C10.14 21 7 17.86 7 14Z"
                                fill="var(--primary)"
                            ></path>
                            </svg>
                        </Link>
                        </span>
                        <input
                        type="text"
                        className="form-control"
                        placeholder="Search here..."
                        onChange={feedbacksFilter}
                        />
                    </div>
                    <Link 
                        to="new-Review"
                        style={{marginLeft : "5px"}}
                        className = "btn bg-primary text-white d-flex justify-content-center align-items-center">
                        New Review
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {feedbacksArray.length == 0 ? (
              <>
                <div className="row d-flex text-center gap-2">
                  <h3>There Is No Data</h3>
                </div>
              </>
            ) : (
              <>
                <div className="col-xl-12 ">
                  <div className="card p-1">
                    <div className="card-body ">
                      <div className="table-responsive">
                        <div
                          id="student_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            className="table display mb-4 dataTablesCard order-table card-table text-black application "
                            id="application-tbl1_next"
                          >
                            <thead>
                              <tr>
                                <th>User</th>
                                <th>Email</th>
                                <th>Message</th>
                                <th>Visability</th>
                                <th>Rating</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {feedbacksArray &&
                                feedbacksArray.map((user, index) => {
                                  console.log(user)
                                  return (
                                    <>
                                      <tr key={user._id}>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <img src={user.image ? `${process.env.REACT_APP_VERSEL_API}/${user.image}` : defaultImg} alt="user img" className="" style={{width: "50px" , marginRight: "2px"}}/>
                                            <h4 className="mb-0 fs-16 font-w500">
                                              {user.name}
                                            </h4>
                                          </div>
                                        </td>
                                        <td>{user.email}</td>
                                        <td><p style={{margin: "0" , textOverflow : "ellipsis" , width: "60px" , overflow : "hidden"}} title={user.message}>{user.message}</p></td>
                                        <td>
                                            <span className={`p-1 text-white ${user.publish ? "bg-secondary" : "bg-danger"} `} style={{borderRadius : "8px"}}>
                                                {
                                                    user.publish
                                                    ?
                                                    "Visable"
                                                    :
                                                    "Not Visable"
                                                }
                                            </span>
                                        </td>
                                        <td>
                                            {
                                                // parseInt(user.rate) > 1
                                                // ?
                                                // `${user.rate} Stars`
                                                // :
                                                // `${user.rate} Star`
                                                calcRate(parseInt(user.rate))
                                            }
                                        </td>
                                        <td>
                                          <CustomDropDownBlog
                                            showupdateform = {() => {
                                                setFeedbackWhichUpdate(user)
                                                setShowUpdateFeedback(true);
                                            }}
                                            deleteJob = {() => deleteFeedback(user._id)}
                                            id={user._id}
                                            dataitem={user}
                                          />
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
      <UpdateFeedbackForm
        show = {showUpdateFeedback}
        hide = {() => setShowUpdateFeedback(false)}
        oldData = {feedbackWhichUpdate}
        refetchData = { () => {
          dispatch(getFeedbacksFunc())
          .then((result) => {
            if (result.payload.message === "fetched successfully") {
              setFeedbacksArray(result.payload.data.feedbacks);
              setBackupData(result.payload.data.feedbacks);
            }
          });
        }}
      />
      <LoadingScreen loading={deleteFeedbackLoading}/>
    </>
  );
};
export default FeedbacksPage;
